import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownTableCellEdit from 'components/organisms/TableCellEdits/DropdownTableCellEdit/DropdownTableCellEdit';
import {rgba} from 'polished';
import FormStyles from 'styles/mixins/Form.styles';

const StyledAnalysisScoreTableCellEdit = styled(DropdownTableCellEdit)`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.layout('1.5sp')};
  padding: ${props => props.theme.layout('2sp')};
  
  .AnalysisScoreTableCellEdit {
    &-form {
      .Form-fields {
        .FormControl {
          &.FormField-name-tagGroup {
            .FormLabel {
              margin-bottom: ${props => props.theme.spacing(0.5)};

              > .Box {
                display: flex;
                width: 100%;

                > .points {
                  margin-left: ${props => props.theme.layout('0.5sp')};
                }
                
                &:has(.FormField-labelPostfix) {
                  > *:nth-child(2) {
                    flex-grow: 1;
                    cursor: default;
                  }
                }
                &:not(:has(.FormField-labelPostfix)) {
                  > *:first-child {
                    flex-grow: 1;
                  }
                }
              }
            }
          }
        }
      }
    }
    
    &-unassigned {
      &-title {
        display: flex;
        width: 100%;

        > *:first-child {
          flex-grow: 1;
          ${props => props.theme.font2Css('body2')};
        }
      }
      &-content {
        text-align: center;
        color: ${props => rgba(props.theme.property('palette.text.primary'), props.theme.property('palette.action.disabledOpacity'))};
        font-style: italic;
        font-size: ${props => props.theme.fontSize(14)};
        margin: ${props => props.theme.spacing(1.5)} 0 ${props => props.theme.spacing(0.5)} 0;
      }
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledAnalysisScoreTableCellEdit.propTypes = {
  theme: PropTypes.object
};

export default StyledAnalysisScoreTableCellEdit;
